var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultCard = function SvgDefaultCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    fillRule: "evenodd",
    stroke: "#F0F1F2",
    strokeWidth: 0.357,
    d: "M1 3a2 2 0 0 1 2-2h31a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E1E5",
    fillRule: "evenodd",
    d: "M1 4.082h35v5.25H1zM3.857 12.69c0-.525.427-.952.953-.952h3.81c.525 0 .952.427.952.953v3.81a.95.95 0 0 1-.953.952H4.81a.95.95 0 0 1-.952-.953zm7.619 0c0-.525.426-.952.952-.952h11.429a.952.952 0 1 1 0 1.905H12.428a.95.95 0 0 1-.952-.952m.952 2.873a.952.952 0 1 0 0 1.904h6.667a.952.952 0 1 0 0-1.904z",
    clipRule: "evenodd"
  })));
};
export default SvgDefaultCard;